import { useDispatch, useSelector } from "react-redux";
import { GlobalState } from "../redux/state";

const ORGS_MODULE_NAME = "organisations";

const orgSelector = (state: GlobalState) => 
  state.organisations.organisation;

export const useOrganisationState = (itemId: string) => {
  const dispatch = useDispatch();

  const orgState = useSelector(orgSelector);
  const isCorrectRecordInRedux =
    orgState.org && String(orgState.org.itemId) === itemId;

  if (!isCorrectRecordInRedux && orgState.status !== "LOADING") {
    dispatch({
      type: `${ORGS_MODULE_NAME}/LOADING_ORGANISATION`,
      payload: itemId,
    });
  }

  return isCorrectRecordInRedux
    ? (orgState)
    : null;
};